import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class SdTruncatePipe implements PipeTransform {
  transform(value: string, limit?: number): string {
    if (limit !== undefined && limit !== null) {
      return value.length > limit ? value.substring(0, limit) + '...' : value;
    } else {
      return value;
    }
  }
}
